// eslint-disable-next-line no-shadow
export enum FailBehaviour {
  restart = 0,
  fail = 1,
  retry = 2,
}

// eslint-disable-next-line no-shadow
export enum ChoiceMetadataType {
  main = 1,
  secondary = 2,
}

// eslint-disable-next-line no-shadow
export enum QuestionResponseType {
  singleAnswer = 1,
  multiCorrect = 2,
  trueOrFalse = 3,
  match = 4,
  order = 5,
  trafficLight = 6,
}

// eslint-disable-next-line no-shadow
export enum TrafficLightType {
  Red = 0,
  Yellow = 1,
  Green = 2,
}

export interface Choice {
  id?: string;
  choiceId?: string;
  content: string;
  position: number;
  type: number;
  disabled?: number;
  isCorrect?: boolean;
  useUUID?: boolean;
}

export interface MatchChoice {
  item: Choice;
  target: Choice;
}

export interface ChoiceDataType {
  id: string;
  tenantId?: string;
  question?: string;
  content: string;
  lcmsReferenceIds?:
    | any
    | {
        id?: number;
        questionId?: number;
      };
  choiceMetadata?:
    | Record<string, any>
    | {
        img: string;
        sound: string;
        position: number;
        type: number;
        disabled: number;
        useUUID?: boolean;
        isCorrect?: boolean;
      };
  isDeleted?: boolean | null;
  createdAt?: string;
  modifiedAt?: string;
}

export interface TrueFalsePropDataType {
  content: string;
  value: number;
}
export interface ChoiceOptionType {
  option: string;
  data: ChoiceDataType;
  isSelected?: any;
}

export interface ChoicePropType {
  questionType: number;
  choiceList: ChoiceOptionType[];
  handler: any;
  isDisabled: boolean;
}

export interface TrueFalsePropType {
  data: TrueFalsePropDataType;
}
export interface TrafficLightPropType {
  option: string;
  data: ChoiceDataType;
}

export interface DeleteResponse {
  raw: any[];
  affected: number;
}
